import { websiteEnv } from '@/constants/website-env';
import { cn } from '@/lib/utils';

const PaymentImages = (props: { className?: string; svgClassName?: string }) => {
  const { className, svgClassName } = props;

  return (
    <div className={cn('flex flex-wrap items-center justify-center gap-2 lg_justify-start', className)}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <path
          fill='#fff'
          stroke='#ABA6A0'
          strokeWidth='0.2'
          d='M1.673.1h37.56a1.62 1.62 0 0 1 1.17.48 1.72 1.72 0 0 1 .487 1.022l.01.167v21.423a1.8 1.8 0 0 1-.507 1.19c-.31.317-.725.501-1.162.517H1.768a1.62 1.62 0 0 1-1.173-.482A1.7 1.7 0 0 1 .1 23.224V1.695A1.63 1.63 0 0 1 .566.565 1.55 1.55 0 0 1 1.673.101Z'
        ></path>
        <path
          fill='#253B80'
          d='M16.388 10.483h-1.86a.23.23 0 0 0-.21.21l-.722 4.772v.104l.102.103h.932a.22.22 0 0 0 .206-.207l.205-1.248a.23.23 0 0 1 .21-.207h.62c1.24 0 1.974-.628 2.065-1.774a1.6 1.6 0 0 0-.218-1.232 1.64 1.64 0 0 0-1.342-.521zm.205 1.77c-.103.628-.62.628-1.137.628h-.308l.308-1.146a.11.11 0 0 1 .098-.107h.107a1.1 1.1 0 0 1 .83.21c.102 0 .205.208.102.398zm5.378 0h-.931a.105.105 0 0 0-.103.103v.207l-.103-.112a1.18 1.18 0 0 0-1.034-.398 2 2 0 0 0-1.32.51 2.02 2.02 0 0 0-.655 1.26 1.52 1.52 0 0 0 .312 1.356 1.41 1.41 0 0 0 1.137.398 1.9 1.9 0 0 0 1.24-.521v.314l.103.103h.83a.22.22 0 0 0 .22-.199l.518-3.022v-.103a.3.3 0 0 1-.206.103zm-1.243 1.665c-.043.242-.171.46-.362.614a1 1 0 0 1-.673.222 1.4 1.4 0 0 1-.624-.211.65.65 0 0 1-.103-.625 1 1 0 0 1 .362-.612c.19-.153.43-.23.673-.219.22.02.432.091.62.207.083.197.119.411.103.624zm5.895-1.666h-.829c-.102 0-.205 0-.205.108l-1.24 1.77-.518-1.77a.22.22 0 0 0-.209-.211h-.928a.1.1 0 0 0-.094.058.1.1 0 0 0-.009.037v.116l.928 2.914-.927 1.352v.2l.102.107h.948c.107 0 .21 0 .21-.108l2.997-4.266v-.207c-.103-.108-.103-.108-.206-.108z'
        ></path>
        <path
          fill='#179BD7'
          d='M29.624 10.49h-1.86a.23.23 0 0 0-.21.211l-.722 4.772v.103l.103.104h.932a.36.36 0 0 0 .205-.104l.21-1.351a.22.22 0 0 1 .205-.207h.62c1.24 0 1.974-.629 2.069-1.774a1.6 1.6 0 0 0-.21-1.248 1.78 1.78 0 0 0-1.342-.525zm.205 1.77c-.102.628-.62.628-1.137.628h-.308l.205-1.252a.1.1 0 0 1 .026-.072.1.1 0 0 1 .07-.032h.216a1.1 1.1 0 0 1 .826.211c.09.156.126.338.102.517m5.268 0h-.924a.105.105 0 0 0-.103.103v.207l-.102-.111a1.18 1.18 0 0 0-1.035-.398 2 2 0 0 0-1.319.51 2.02 2.02 0 0 0-.655 1.26 1.52 1.52 0 0 0 .312 1.356 1.41 1.41 0 0 0 1.137.397 1.9 1.9 0 0 0 1.24-.52v.314l.103.103h.829a.22.22 0 0 0 .205-.207l.518-3.022v-.103a.3.3 0 0 1-.206.103zm-1.244 1.666c-.043.241-.17.458-.36.612s-.427.233-.67.223a1.4 1.4 0 0 1-.624-.21.65.65 0 0 1-.103-.625c.043-.24.17-.456.359-.609a1 1 0 0 1 .668-.222c.22.02.431.091.62.207.083.197.118.41.102.624zm2.275-3.225-.715 4.891v.104l.103.107h.727a.224.224 0 0 0 .205-.21l.722-4.772v-.104l-.098-.119h-.83c0-.107-.106 0-.106.103z'
        ></path>
        <path
          fill='#253B80'
          d='m5.945 16.625.106-.938H4.294l1.03-6.66v-.104h2.587a2.53 2.53 0 0 1 1.758.52q.144.242.205.518v.938l.106.104c.103.103.206.103.309.21.129.143.202.328.205.521v.716a8 8 0 0 1-.308.831 1.2 1.2 0 0 1-.517.52l-.636.327a2.3 2.3 0 0 1-.83.103h-.205a.65.65 0 0 0-.62.521v.104l-.205 1.666v.103z'
        ></path>
        <path
          fill='#179BD7'
          d='m9.845 10.59-.023.27c-.312 1.77-1.067 2.327-2.512 2.327h-.83a.275.275 0 0 0-.307.314l-.395 2.386-.142.74v.103l.102.103h1.45a.27.27 0 0 0 .273-.133.28.28 0 0 0 .035-.177v-.096l.209-1.562v-.104a.49.49 0 0 1 .308-.314h.205c1.244 0 2.275-.52 2.587-1.988a2.33 2.33 0 0 0-.51-1.873z'
        ></path>
        <path
          fill='#222D65'
          d='M10.308 10.604H6.864a.275.275 0 0 0-.308.314l-.414 2.6v.104a.33.33 0 0 1 .308-.31h.726c1.446 0 2.697-.191 3.01-1.853'
        ></path>
        <path
          fill='#253B80'
          d='M6.573 10.902a.49.49 0 0 1 .312-.31h3.432a1.52 1.52 0 0 0-.332-1.36c-.395-.418-1.03-.628-1.975-.628H5.333a.275.275 0 0 0-.274.139.28.28 0 0 0-.034.175l-1.035 6.76v.206a.36.36 0 0 0 .206.104h1.552l.414-2.386z'
        ></path>
      </svg>

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <path
          fill='#21569A'
          d='M.018 2.004c0-.531.205-1.041.57-1.417S1.448 0 1.964 0h36.769a2 2 0 0 1 1.413.576c.38.375.603.887.623 1.428v12.679c0 .531-.206 1.041-.57 1.417-.366.376-.86.587-1.377.587H2.057a2 2 0 0 1-1.414-.576 2.1 2.1 0 0 1-.625-1.428z'
        ></path>
        <path
          fill='#F4AD0F'
          d='M.208 9.188h38.723a1.85 1.85 0 0 1 1.33.557c.354.36.554.85.558 1.363v.052l.163 11.836c0 .532-.205 1.042-.57 1.418s-.86.587-1.376.587H2.244a2 2 0 0 1-1.412-.578 2.1 2.1 0 0 1-.624-1.427z'
        ></path>
        <path
          fill='#fff'
          d='m41 19.637-41-.005V5.25l40.825-.016z'
        ></path>
        <path
          fill='#21569A'
          d='m19.993 8.29-2.137 9.99h-2.651l2.242-9.97zM31 14.705l1.323-3.78.818 3.78zm2.853 3.567h2.46l-2.137-9.968h-2.242a1.23 1.23 0 0 0-.662.201 1.3 1.3 0 0 0-.459.532l-3.892 9.22h2.775l.51-1.468h3.382l.304 1.468zm-6.726-3.262c0-2.626-3.667-2.73-3.667-4.009 0-.316.304-.737 1.121-.841a5.3 5.3 0 0 1 2.546.42l.389-2.1a7.5 7.5 0 0 0-2.448-.4c-2.546 0-4.38 1.362-4.38 3.25 0 1.471 1.324 2.205 2.243 2.73 1.02.525 1.323.838 1.323 1.258 0 .63-.813.946-1.53.946a5.2 5.2 0 0 1-2.647-.629l-.389 2.2a7 7 0 0 0 2.853.526c2.752 0 4.485-1.259 4.586-3.351M16.326 8.29l-4.177 9.988H9.292l-2.036-7.976a.94.94 0 0 0-.177-.52.9.9 0 0 0-.434-.322 12.2 12.2 0 0 0-2.55-.842l.102-.312H8.58c.293-.008.579.094.804.287.225.194.373.465.418.763l1.121 5.772 2.752-6.718 2.651-.104z'
        ></path>
      </svg>

      {websiteEnv.isUnitedStates ||
      websiteEnv.isCanada ||
      websiteEnv.isGermanyEnglish ||
      websiteEnv.isUnitedKingdom ||
      websiteEnv.isIreland ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='41'
          height='25'
          fill='none'
          viewBox='0 0 41 25'
          className={cn('flex-none', svgClassName)}
        >
          <rect
            width='41'
            height='25'
            fill='#FFA8CD'
            rx='2'
          ></rect>
          <path
            fill='#0A0B09'
            d='M37.476 14.424a1.023 1.023 0 0 0-1.025 1.019v.001a1.02 1.02 0 0 0 1.022 1.02h.002c.564 0 1.025-.457 1.025-1.02a1.02 1.02 0 0 0-1.022-1.02zm-3.372-.788c0-.772-.663-1.397-1.48-1.397s-1.48.625-1.48 1.397c0 .773.663 1.397 1.48 1.397s1.48-.626 1.48-1.397m.006-2.715h1.632v5.43H34.11v-.348a2.9 2.9 0 0 1-1.619.497 2.87 2.87 0 0 1-2.878-2.865 2.87 2.87 0 0 1 2.878-2.865c.6 0 1.158.182 1.619.497zm-13.068.706v-.706H19.37v5.43h1.675v-2.537c0-.854.93-1.315 1.577-1.315h.019v-1.578c-.663 0-1.27.283-1.599.706m-4.164 2.01c0-.773-.663-1.398-1.48-1.398-.818 0-1.48.625-1.48 1.397 0 .771.662 1.397 1.48 1.397s1.48-.626 1.48-1.397m.005-2.716h1.634v5.43h-1.634v-.348a2.87 2.87 0 0 1-1.619.497 2.87 2.87 0 0 1-2.878-2.865 2.87 2.87 0 0 1 2.878-2.865c.601 0 1.159.182 1.62.497zm9.829-.146c-.651 0-1.27.201-1.683.757v-.611h-1.626v5.43h1.647v-2.854c0-.825.556-1.23 1.226-1.23.717 0 1.13.428 1.13 1.218v2.865h1.63v-3.452c0-1.264-1.01-2.123-2.324-2.123M10.008 16.35h1.71V8.501h-1.71zm-7.508.002h1.81V8.5H2.502zM8.83 8.5c0 1.7-.665 3.281-1.85 4.457l2.502 3.395H7.247l-2.718-3.69.702-.523A4.5 4.5 0 0 0 7.059 8.5z'
          ></path>
        </svg>
      ) : null}

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <rect
          width='40.8'
          height='24.8'
          x='0.1'
          y='0.1'
          fill='#fff'
          rx='1.9'
        ></rect>
        <rect
          width='40.8'
          height='24.8'
          x='0.1'
          y='0.1'
          stroke='#ABA6A0'
          strokeWidth='0.2'
          rx='1.9'
        ></rect>
        <path
          fill='#000'
          d='M17.172 8.11v7.921h1.265V13.31h1.772c1.604 0 2.743-1.056 2.743-2.6 0-1.543-1.097-2.6-2.7-2.6zm1.308 1.056h1.476c1.097 0 1.73.568 1.73 1.584s-.633 1.584-1.73 1.584H18.48zm6.834 6.947c.802 0 1.561-.407 1.898-1.016h.043v.934h1.18v-3.94c0-1.138-.927-1.87-2.404-1.87-1.35 0-2.362.732-2.404 1.788h1.139c.084-.487.548-.812 1.223-.812.76 0 1.223.366 1.223.975v.447l-1.603.081c-1.476.081-2.278.65-2.278 1.666-.042 1.056.802 1.747 1.983 1.747m.338-.935c-.675 0-1.097-.325-1.097-.812s.422-.772 1.223-.813l1.435-.081v.447c-.043.731-.718 1.26-1.561 1.26m4.303 3.006c1.223 0 1.814-.447 2.32-1.828l2.278-6.053h-1.308l-1.518 4.672h-.043l-1.518-4.672h-1.35l2.151 5.769-.126.366c-.211.609-.507.812-1.055.812h-.38v.934zM10.106 9.055c.635.052 1.27-.313 1.64-.782s.635-1.095.582-1.773c-.529 0-1.27.365-1.64.834-.37.417-.635 1.095-.582 1.72M10.212 9.732c.423 0 1.217-.573 2.116-.521.37 0 1.376.104 1.958.99-.053.053-1.217.678-1.217 2.086 0 1.668 1.482 2.241 1.482 2.241 0 .053-.212.782-.741 1.564-.423.678-.953 1.356-1.693 1.356-.741.052-1.006-.417-1.853-.417-.846 0-1.11.469-1.799.469-.74 0-1.27-.73-1.746-1.408-.953-1.355-1.693-3.857-.688-5.526.53-.834 1.376-1.355 2.328-1.355.688 0 1.376.521 1.852.521'
        ></path>
      </svg>

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <rect
          width='40.8'
          height='24.8'
          x='0.1'
          y='0.1'
          fill='#fff'
          rx='1.9'
        ></rect>
        <rect
          width='40.8'
          height='24.8'
          x='0.1'
          y='0.1'
          stroke='#ABA6A0'
          strokeWidth='0.2'
          rx='1.9'
        ></rect>
        <path
          fill='#3C4043'
          d='M18.983 12.207v3.464h-1.271V7.118h3.37c.402-.007.802.054 1.176.181s.715.317 1.002.558c.289.232.518.512.676.823.157.311.238.647.238.986 0 .34-.081.675-.238.986a2.5 2.5 0 0 1-.676.823c-.288.24-.63.428-1.004.553a3.5 3.5 0 0 1-1.174.176h-2.099zm0-4.036v2.983h2.125c.23.002.459-.035.673-.109.213-.073.408-.183.572-.32.164-.14.295-.304.385-.486s.137-.377.138-.574a1.26 1.26 0 0 0-.13-.565 1.45 1.45 0 0 0-.38-.476 1.7 1.7 0 0 0-.571-.344 1.9 1.9 0 0 0-.687-.109zm8.514 1.454c.812-.038 1.61.196 2.224.653.276.231.492.51.633.818.14.308.202.638.182.968v3.607h-1.214v-.813h-.054a2.3 2.3 0 0 1-.893.74 2.7 2.7 0 0 1-1.205.262 3 3 0 0 1-1.874-.573 1.9 1.9 0 0 1-.565-.643 1.6 1.6 0 0 1-.19-.788 1.53 1.53 0 0 1 .192-.804c.138-.252.345-.47.602-.639a3.7 3.7 0 0 1 2.12-.538 4.2 4.2 0 0 1 1.86.36v-.252a1.1 1.1 0 0 0-.134-.537 1.3 1.3 0 0 0-.39-.436 1.97 1.97 0 0 0-1.231-.4 2.2 2.2 0 0 0-.962.197 1.84 1.84 0 0 0-.72.58l-1.12-.606a3 3 0 0 1 1.192-.887 3.54 3.54 0 0 1 1.547-.269m-1.642 4.249a.77.77 0 0 0 .11.402.9.9 0 0 0 .314.314c.28.19.628.291.986.286.266 0 .53-.046.776-.134.245-.089.468-.218.654-.381.198-.152.356-.339.465-.547a1.4 1.4 0 0 0 .164-.66 2.93 2.93 0 0 0-1.655-.407 2.43 2.43 0 0 0-1.29.32 1.06 1.06 0 0 0-.38.348.9.9 0 0 0-.143.459zm11.593-4.06-4.237 8.431h-1.315l1.579-2.948-2.793-5.483h1.384l2.012 4.202h.027l1.96-4.202z'
        ></path>
        <path
          fill='#4285F4'
          d='M13.927 11.515q0-.52-.105-1.03H8.493v1.882h3.069c-.059.307-.19.6-.386.863a2.5 2.5 0 0 1-.753.66v1.226h1.821a4.85 4.85 0 0 0 1.282-1.65c.29-.62.427-1.284.401-1.951'
        ></path>
        <path
          fill='#34A853'
          d='M10.423 13.898c-.44.244-.94.398-1.46.45A4 4 0 0 1 7.42 14.2a3.5 3.5 0 0 1-1.307-.718 2.9 2.9 0 0 1-.804-1.138H3.425v1.264c.468.81 1.19 1.491 2.086 1.968.895.478 1.928.731 2.982.733 1.383.033 2.729-.392 3.756-1.186z'
        ></path>
        <path
          fill='#FABB05'
          d='M5.13 11.402c0-.318.06-.635.177-.937v-1.27H3.429a4.4 4.4 0 0 0-.603 2.203c0 .764.207 1.518.603 2.203l1.885-1.264a2.6 2.6 0 0 1-.185-.935'
        ></path>
        <path
          fill='#E94235'
          d='M8.493 8.442c.81-.011 1.593.253 2.176.736l1.619-1.4C11.265 6.947 9.904 6.488 8.493 6.5a6.4 6.4 0 0 0-2.982.733c-.896.477-1.618 1.159-2.086 1.969l1.884 1.263c.218-.58.642-1.087 1.213-1.45a3.8 3.8 0 0 1 1.971-.573'
        ></path>
      </svg>

      {websiteEnv.isUnitedStates || websiteEnv.isCanada ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='41'
          height='25'
          fill='none'
          viewBox='0 0 41 25'
          className={cn('hidden flex-none', svgClassName)}
        >
          <rect
            width='40.8'
            height='24.8'
            x='0.1'
            y='0.1'
            fill='#fff'
            rx='1.9'
          ></rect>
          <rect
            width='40.8'
            height='24.8'
            x='0.1'
            y='0.1'
            stroke='#ABA6A0'
            strokeWidth='0.2'
            rx='1.9'
          ></rect>
          <path
            fill='#3ED7AB'
            d='m4.364 9.696.251 2.778s.627-.623 1.528-1.562c.195-.2.341-.444.426-.713s.106-.554.062-.832a2.55 2.55 0 0 0-.616-1.36z'
          ></path>
          <path
            fill='#F95572'
            d='m6.03 14.081-.096-2.939s-.703.701.216-.22a1.71 1.71 0 0 1 1.514-.5c.494.068.957.288 1.326.63z'
          ></path>
          <path
            fill='#FD7A08'
            d='m7.338 12.735.252 2.78s.627-.625 1.528-1.564a1.827 1.827 0 0 0 .488-1.546 2.55 2.55 0 0 0-.617-1.358z'
          ></path>
          <path
            fill='#18BB8E'
            d='m4.618 12.481-.25-2.778s-.627.623-1.528 1.562a1.826 1.826 0 0 0-.489 1.549c.068.505.282.978.617 1.358z'
          ></path>
          <path
            fill='#A24AD6'
            d='m5.927 11.133.095 2.938s.702-.7-.217.222c-.195.2-.434.349-.697.436a1.7 1.7 0 0 1-.816.064 2.44 2.44 0 0 1-1.327-.63z'
          ></path>
          <path
            fill='#F6A91D'
            d='m7.594 15.52-.252-2.778s-.627.623-1.528 1.562c-.195.2-.341.445-.426.714-.085.27-.106.555-.062.834.067.506.282.98.617 1.359z'
          ></path>
          <path
            fill='#522A80'
            d='M17.772 15.804a2.24 2.24 0 0 1-1.249-.68 2.33 2.33 0 0 1-.607-1.308 2.4 2.4 0 0 1 .373-1.673 2.3 2.3 0 0 1 1.384-.969 2.28 2.28 0 0 1 1.647.218c.504.278.89.735 1.085 1.286.13.372.038.554-.341.667l-2.917.873q-.105.027-.212.065c.14.255.35.462.604.597.253.135.54.19.824.162.236-.027.463-.108.664-.237.2-.13.37-.303.497-.509.163-.255.382-.326.587-.198.215.137.241.368.076.643a2.4 2.4 0 0 1-.849.811 2.3 2.3 0 0 1-1.125.297q-.224 0-.44-.045m-.07-3.805a1.45 1.45 0 0 0-.749.58c-.18.274-.265.6-.243.928l2.805-.837a1.53 1.53 0 0 0-.79-.668 1.5 1.5 0 0 0-1.024-.003m17.307 3.797a2.24 2.24 0 0 1-1.249-.681 2.33 2.33 0 0 1-.606-1.308 2.4 2.4 0 0 1 .372-1.674 2.3 2.3 0 0 1 1.387-.97 2.28 2.28 0 0 1 1.647.217c.504.277.89.734 1.086 1.285.13.372.038.554-.34.667l-2.916.873c-.072.018-.143.043-.216.066.14.255.35.462.604.597.253.134.54.19.824.162a1.55 1.55 0 0 0 .664-.237 1.6 1.6 0 0 0 .497-.508c.164-.255.381-.327.587-.199.214.138.242.368.076.643a2.4 2.4 0 0 1-.849.81 2.3 2.3 0 0 1-1.125.298 2 2 0 0 1-.442-.045v.004m-.069-3.804a1.45 1.45 0 0 0-.748.58c-.18.273-.266.6-.244.927l2.805-.837a1.53 1.53 0 0 0-.789-.667 1.5 1.5 0 0 0-1.024-.003m-3.683 3.549a1 1 0 0 1-.015-.206v-5.76c0-.318.101-.473.317-.5.257-.033.425.132.425.43q.004 1.47 0 2.939v2.96c0 .266-.124.42-.337.433h-.036a.34.34 0 0 1-.233-.079.35.35 0 0 1-.121-.217m-19.724-.235a.4.4 0 0 1-.203-.264.42.42 0 0 1 .059-.33.4.4 0 0 1 .281-.175.4.4 0 0 1 .314.101c.404.306.908.438 1.407.365.176-.03.346-.092.5-.184a.468.468 0 0 0 .225-.467.4.4 0 0 0-.106-.227.38.38 0 0 0-.22-.113c-.383-.097-.776-.167-1.164-.253a6 6 0 0 1-.524-.13 1.1 1.1 0 0 1-.6-.367 1.14 1.14 0 0 1-.263-.662 1.25 1.25 0 0 1 .128-.703c.11-.216.281-.394.49-.51a2.15 2.15 0 0 1 1.892-.12q.299.108.569.276c.286.163.368.392.235.617-.124.214-.358.25-.632.084a1.82 1.82 0 0 0-1.133-.312 1.15 1.15 0 0 0-.559.197.55.55 0 0 0-.18.427.46.46 0 0 0 .29.292c.427.115.867.18 1.298.28q.31.065.599.199c.183.089.342.224.46.393a1.245 1.245 0 0 1-.222 1.673 2 2 0 0 1-1.432.438h-.02a2.57 2.57 0 0 1-1.488-.525m14.836.517a.33.33 0 0 1-.262-.114.37.37 0 0 1 .049-.288c.404-.618.816-1.228 1.226-1.841l1.003-1.496c.038-.057.068-.115.13-.217h-1.87c-.37 0-.557-.133-.55-.388.006-.255.176-.37.541-.37.932 0 1.864-.004 2.8.006a.39.39 0 0 1 .297.134c.038.063-.015.219-.07.305q-1.067 1.604-2.138 3.204c-.062.093-.121.187-.213.33h2.115c.256 0 .393.12.411.329a.37.37 0 0 1-.097.306.36.36 0 0 1-.296.107h-1.578q-.75 0-1.498-.006m-4.815 0a.33.33 0 0 1-.26-.114.37.37 0 0 1 .049-.288c.404-.618.816-1.228 1.226-1.841l1.004-1.496c.037-.057.067-.115.127-.217h-1.87c-.37 0-.557-.133-.55-.388.005-.255.176-.37.54-.37.932 0 1.865-.004 2.8.006a.39.39 0 0 1 .297.134c.038.063-.014.219-.07.305-.71 1.07-1.427 2.137-2.14 3.204-.062.093-.122.187-.213.33h2.115c.256 0 .393.12.41.329a.37.37 0 0 1-.096.306.35.35 0 0 1-.296.107h-1.58q-.746 0-1.494-.006z'
          ></path>
        </svg>
      ) : null}

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <rect
          width='40.8'
          height='24.035'
          x='0.1'
          y='0.483'
          fill='#fff'
          rx='1.9'
        ></rect>
        <rect
          width='40.8'
          height='24.035'
          x='0.1'
          y='0.483'
          stroke='#ABA6A0'
          strokeWidth='0.2'
          rx='1.9'
        ></rect>
        <path
          fill='#000'
          d='M12.038 22.534v-1.563a1 1 0 0 0-.05-.386 1 1 0 0 0-.185-.33.8.8 0 0 0-.288-.212.7.7 0 0 0-.34-.06.76.76 0 0 0-.435.1.9.9 0 0 0-.331.335.86.86 0 0 0-.31-.33.73.73 0 0 0-.415-.105.65.65 0 0 0-.363.088.77.77 0 0 0-.277.282v-.31h-.48v2.491h.468v-1.38a.7.7 0 0 1 .019-.254.6.6 0 0 1 .112-.22.5.5 0 0 1 .185-.146.46.46 0 0 1 .22-.042c.32 0 .476.235.476.658v1.384h.483v-1.38a.7.7 0 0 1 .02-.253.6.6 0 0 1 .113-.22.5.5 0 0 1 .184-.145.5.5 0 0 1 .22-.044c.326 0 .483.235.483.658v1.384zm7.124-2.49h-.767v-.753h-.491v.753h-.437v.496h.445v1.15c0 .578.195.922.766.922.21.001.416-.065.595-.191l-.138-.462a.8.8 0 0 1-.422.14c-.238 0-.318-.166-.318-.436V20.54h.767zm4.056-.061a.6.6 0 0 0-.334.092.7.7 0 0 0-.245.274v-.3h-.46v2.49h.475v-1.394c0-.409.157-.64.468-.64a.7.7 0 0 1 .299.061l.146-.51a.9.9 0 0 0-.338-.069zm-6.134.261a1.5 1.5 0 0 0-.894-.261c-.556 0-.912.3-.912.797 0 .404.264.657.766.735l.227.035c.26.044.383.118.383.261s-.172.3-.498.3a1.06 1.06 0 0 1-.729-.26l-.226.435c.278.22.612.333.95.322.634 0 1.002-.34 1.002-.814 0-.475-.288-.666-.767-.745l-.226-.034c-.207-.03-.384-.079-.384-.244 0-.166.157-.292.418-.292.24.005.475.078.683.213zm12.77-.261a.6.6 0 0 0-.333.092.7.7 0 0 0-.245.274v-.3h-.472v2.49h.475v-1.394c0-.409.157-.64.468-.64a.7.7 0 0 1 .3.061l.145-.51a.9.9 0 0 0-.338-.069zm-6.134 1.306c-.006.173.02.346.076.508.055.161.14.308.248.43q.164.186.38.282a1 1 0 0 0 .446.086c.287.017.569-.089.79-.296l-.23-.435a.9.9 0 0 1-.571.222.66.66 0 0 1-.496-.234.86.86 0 0 1-.206-.563c0-.211.074-.414.206-.563a.66.66 0 0 1 .496-.234.9.9 0 0 1 .571.222l.23-.435a1.06 1.06 0 0 0-.79-.296 1 1 0 0 0-.447.086q-.215.096-.38.281c-.107.123-.192.27-.247.431a1.4 1.4 0 0 0-.076.508m4.467 0v-1.245H27.7v.3a.86.86 0 0 0-.308-.279.75.75 0 0 0-.386-.087c-.305 0-.598.138-.814.383a1.4 1.4 0 0 0-.336.924c0 .346.12.678.336.923s.509.383.814.383a.75.75 0 0 0 .386-.087.86.86 0 0 0 .308-.28v.301h.475zm-1.776 0a.8.8 0 0 1 .132-.409.68.68 0 0 1 .31-.257.6.6 0 0 1 .382-.02.65.65 0 0 1 .329.222.846.846 0 0 1 .112.823.73.73 0 0 1-.254.326.6.6 0 0 1-.37.112.6.6 0 0 1-.265-.059.7.7 0 0 1-.22-.174.8.8 0 0 1-.142-.261.8.8 0 0 1-.037-.303zm-5.75-1.306a1.1 1.1 0 0 0-.81.395c-.212.248-.33.582-.325.928.004.347.129.677.348.919.218.241.512.375.817.37.327.013.646-.111.897-.348l-.233-.4a.97.97 0 0 1-.637.26.56.56 0 0 1-.436-.154.72.72 0 0 1-.22-.455h1.622v-.21a1.4 1.4 0 0 0-.048-.487 1.2 1.2 0 0 0-.218-.425 1.1 1.1 0 0 0-.35-.289.95.95 0 0 0-.423-.104zm0 .483a.5.5 0 0 1 .209.042q.1.046.179.13a.6.6 0 0 1 .122.198.7.7 0 0 1 .046.235h-1.15a.68.68 0 0 1 .182-.438.53.53 0 0 1 .4-.167zm11.962.823v-2.242h-.499v1.306a.86.86 0 0 0-.308-.279.75.75 0 0 0-.386-.087c-.305 0-.597.138-.813.383a1.4 1.4 0 0 0-.337.923c0 .347.121.679.337.924s.508.382.813.382a.75.75 0 0 0 .386-.087.86.86 0 0 0 .308-.278v.3h.475zm-1.776 0a.8.8 0 0 1 .13-.406.68.68 0 0 1 .305-.258.6.6 0 0 1 .38-.026.65.65 0 0 1 .33.216c.088.107.148.241.17.386a.85.85 0 0 1-.043.429.74.74 0 0 1-.244.331.61.61 0 0 1-.85-.108.8.8 0 0 1-.14-.261.8.8 0 0 1-.038-.303m-16.102 0v-1.245h-.495v.3a.86.86 0 0 0-.307-.279.75.75 0 0 0-.387-.087c-.305 0-.597.138-.813.383a1.4 1.4 0 0 0-.337.924c0 .346.121.678.337.923s.508.383.813.383a.75.75 0 0 0 .387-.087.86.86 0 0 0 .307-.28v.301h.476zm-1.775 0a.8.8 0 0 1 .13-.406.7.7 0 0 1 .305-.258.6.6 0 0 1 .38-.026.65.65 0 0 1 .329.216c.089.107.148.241.17.386a.85.85 0 0 1-.043.429.74.74 0 0 1-.244.331.6.6 0 0 1-.364.125.6.6 0 0 1-.27-.052.66.66 0 0 1-.229-.173.8.8 0 0 1-.145-.264.8.8 0 0 1-.039-.308zm20.442.87a.2.2 0 0 1 .085 0 .22.22 0 0 1 .115.131.27.27 0 0 1-.046.27.2.2 0 0 1-.07.052.2.2 0 0 1-.084 0 .2.2 0 0 1-.125-.01.23.23 0 0 1-.1-.085.27.27 0 0 1 .045-.27.22.22 0 0 1 .161-.074zm0 .436a.14.14 0 0 0 .066 0 .2.2 0 0 0 .053-.04.2.2 0 0 0 .05-.136.2.2 0 0 0-.05-.137.2.2 0 0 0-.053-.04.15.15 0 0 0-.066 0 .2.2 0 0 0-.065 0 .2.2 0 0 0-.053.04.2.2 0 0 0-.05.137c0 .05.018.1.05.137q.023.025.053.039.022.012.046.017zm0-.31a.08.08 0 0 1 .062 0 .1.1 0 0 1 .015.024q.004.015.004.03a.07.07 0 0 1 0 .047.08.08 0 0 1-.046.022l.065.087h-.054l-.061-.087h-.02v.087h-.041v-.23zm-.05.044v.061h.077a.03.03 0 0 0 0-.021.03.03 0 0 0 0-.022h-.027z'
        ></path>
        <path
          fill='#FF5F00'
          d='M16.555 4.04h6.803v12.192h-6.803z'
        ></path>
        <path
          fill='#EB001B'
          d='M16.987 10.14a7.72 7.72 0 0 1 2.97-6.098 7.79 7.79 0 0 0-8.207-.88 7.77 7.77 0 0 0-3.194 2.861 7.74 7.74 0 0 0 0 8.23 7.77 7.77 0 0 0 3.194 2.86 7.8 7.8 0 0 0 8.207-.878 7.72 7.72 0 0 1-2.97-6.095'
        ></path>
        <path
          fill='#F79E1B'
          d='M32.542 10.142c.001 1.455-.41 2.88-1.183 4.115a7.77 7.77 0 0 1-3.194 2.86 7.79 7.79 0 0 1-8.206-.88 7.737 7.737 0 0 0 0-12.193 7.79 7.79 0 0 1 8.207-.881 7.77 7.77 0 0 1 3.194 2.862 7.74 7.74 0 0 1 1.182 4.117m-.744 4.805v-.249h.101v-.05h-.256v.05h.1v.249zm.499 0v-.303h-.08l-.09.206-.09-.206h-.08v.303h.054v-.227l.087.194h.058l.086-.194v.227z'
        ></path>
      </svg>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <path
          fill='#1477BE'
          d='M39.262 25H1.738a1.69 1.69 0 0 1-1.209-.478A1.75 1.75 0 0 1 0 23.317V1.667C.017 1.214.209.784.534.472a1.68 1.68 0 0 1 1.204-.47h37.524c.447-.01.88.158 1.204.47.325.312.517.742.534 1.197v21.649c-.014.457-.204.89-.53 1.205-.325.315-.759.487-1.208.478'
        ></path>
        <path
          fill='#fff'
          d='M6.541 12.799h2.343L7.658 9.986zm21.566-2.415h-3.78v1.25h3.78v1.455h-3.78v1.46h3.886v1.043a21 21 0 0 1 2.042-2.292l.715-.835-2.855-3.207v1.146z'
        ></path>
        <path
          fill='#fff'
          d='M39.16 7.285h-5.725l-1.331 1.46-1.215-1.46H17.485l-1.023 2.499-1.125-2.503H5.503L1.43 17.185h4.909l.613-1.667h1.43l.636 1.667h21.777l1.328-1.564 1.332 1.564h5.725l-4.518-4.898zm-17.996 8.44h-1.636v-5.416l-2.343 5.415h-1.328l-2.344-5.415-.101 5.415h-3.27l-.616-1.667H6.15l-.714 1.667H3.699l2.976-7.082H9.13l2.62 6.458V8.642h2.66l2.149 4.687 1.952-4.687h2.66v7.082zm15.032 0H34.15l-2.046-2.388-2.043 2.387h-7.374V8.642h7.667l1.843 2.292 2.043-2.292h2.046l-3.16 3.53z'
        ></path>
      </svg>

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <path
          fill='#F9F9F9'
          stroke='#ABA6A0'
          strokeWidth='0.2'
          d='M2.291.1h36.418c.58 0 1.138.234 1.549.652s.642.985.642 1.577v20.342a2.25 2.25 0 0 1-.642 1.577 2.17 2.17 0 0 1-1.549.652H2.291c-.58 0-1.138-.234-1.549-.652A2.25 2.25 0 0 1 .1 22.671V2.329C.1 1.737.33 1.17.742.752A2.17 2.17 0 0 1 2.291.1Z'
        ></path>
        <path
          fill='#0079BF'
          d='M22.095 23.194a10.4 10.4 0 0 0 4.063-.698 10.5 10.5 0 0 0 3.488-2.23 10.7 10.7 0 0 0 2.377-3.42 10.84 10.84 0 0 0 .19-8.211 10.7 10.7 0 0 0-2.215-3.531 10.5 10.5 0 0 0-3.38-2.395 10.4 10.4 0 0 0-4.025-.893q-.054.002-.106-.004H16.61a10.44 10.44 0 0 0-7.308 3.204 10.78 10.78 0 0 0-3.01 7.487c0 2.8 1.08 5.489 3.01 7.488a10.44 10.44 0 0 0 7.308 3.203z'
        ></path>
        <path
          fill='#fff'
          d='M16.683 22.337c5.333 0 9.656-4.394 9.656-9.813S22.016 2.71 16.682 2.71s-9.656 4.393-9.656 9.813 4.323 9.813 9.656 9.813'
        ></path>
        <path
          fill='#0079BF'
          d='M14.568 18.318a6.1 6.1 0 0 1-2.843-2.266 6.25 6.25 0 0 1-1.075-3.506c0-1.253.375-2.475 1.075-3.506a6.1 6.1 0 0 1 2.843-2.267zM18.97 18.318a6.1 6.1 0 0 0 2.844-2.266 6.25 6.25 0 0 0 1.074-3.506 6.25 6.25 0 0 0-1.074-3.506 6.1 6.1 0 0 0-2.843-2.267z'
        ></path>
      </svg>

      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='41'
        height='25'
        fill='none'
        viewBox='0 0 41 25'
        className={cn('flex-none', svgClassName)}
      >
        <path
          fill='#F9F9F9'
          stroke='#ABA6A0'
          strokeWidth='0.2'
          d='M2.291.1h36.418c.58 0 1.138.234 1.549.652s.642.985.642 1.577v20.342a2.25 2.25 0 0 1-.642 1.577 2.17 2.17 0 0 1-1.549.652H2.291c-.58 0-1.138-.234-1.549-.652A2.25 2.25 0 0 1 .1 22.671V2.329C.1 1.737.33 1.17.742.752A2.17 2.17 0 0 1 2.291.1Z'
        ></path>
        <path
          fill='#016AB6'
          d='M11.19 2.484h3.228v15.148c0 1.32-.516 2.585-1.434 3.518a4.86 4.86 0 0 1-3.462 1.458H6.294V7.48a5 5 0 0 1 .365-1.905 5 5 0 0 1 1.055-1.62 4.9 4.9 0 0 1 1.584-1.084 4.8 4.8 0 0 1 1.873-.387z'
        ></path>
        <path
          fill='#fff'
          d='m10.886 9.489 2.808-.028.02 4.224s.117 1.843-2.48 2.32a11.4 11.4 0 0 1-4.966-.302 14 14 0 0 1 0-1.421s3.286 1.7 4.398 0c.114-.174.176-.377.177-.585z'
        ></path>
        <path
          fill='#C6283F'
          d='M20.82 2.484h3.227v15.148a5.02 5.02 0 0 1-1.433 3.517 4.86 4.86 0 0 1-3.46 1.459h-3.227V7.48a5.05 5.05 0 0 1 .365-1.905 5 5 0 0 1 1.055-1.62 4.9 4.9 0 0 1 1.584-1.084 4.8 4.8 0 0 1 1.873-.387z'
        ></path>
        <path
          fill='#fff'
          d='M23.14 9.744v1.41s-1.69-.94-3.358-.71c-1.669.232-2.84 2.286-1.296 4.041 0 0 1.421 1.314 4.633-.15v1.349s-4.512 1.465-7.203-.621v-4.706s2.033-1.919 7.223-.613'
        ></path>
        <path
          fill='#36A239'
          d='M30.406 2.484h3.243v15.148c0 1.32-.516 2.585-1.434 3.518a4.86 4.86 0 0 1-3.462 1.458h-3.228V7.48c0-1.32.516-2.585 1.435-3.518a4.86 4.86 0 0 1 3.462-1.458z'
        ></path>
        <path
          fill='#fff'
          d='m25.51 9.548-.027 6.489 5.504-.032s1.853-.247 1.743-1.724c0-.063.157-1.313-1.911-1.62 0 0 1.633.06 1.508-1.787 0 0 .058-.968-1.508-1.27s-5.273-.056-5.308-.056'
        ></path>
        <path
          fill='#36A239'
          d='M27.118 10.492v1.644h1.88s.74-.23.698-.855a.9.9 0 0 0-.21-.514.86.86 0 0 0-.472-.283zM27.118 13.086v1.815h2.068s.823-.262.784-.951a.98.98 0 0 0-.232-.562.95.95 0 0 0-.516-.31z'
        ></path>
      </svg>

      {websiteEnv.isUnitedStates ? (
        <>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='41'
            height='25'
            fill='none'
            viewBox='0 0 41 25'
            className={cn('flex-none', svgClassName)}
          >
            <rect
              width='40.8'
              height='24.8'
              x='0.1'
              y='0.1'
              fill='#fff'
              rx='1.9'
            ></rect>
            <rect
              width='40.8'
              height='24.8'
              x='0.1'
              y='0.1'
              stroke='#ABA6A0'
              strokeWidth='0.2'
              rx='1.9'
            ></rect>
            <path
              fill='#000'
              d='M6.408 14.202c.307-.3.615-.6.82-1q.307-.6.307-1.2c0-1.6-1.23-2.8-3.177-2.8H2.615v5.6h1.64c.923 0 1.538-.2 2.153-.6m-2.665-.3v-3.6h.307c.718 0 1.23.1 1.538.4.41.4.615.8.615 1.4 0 .5-.205 1.1-.615 1.4s-.82.4-1.538.4zm4.202-4.7h1.128v5.6H7.945zm3.485 4.8c-.512 0-1.025-.2-1.23-.7l-.717.7c.512.7 1.127 1.1 2.05 1.1 1.23 0 2.05-.7 2.05-1.8 0-.9-.41-1.3-1.64-1.8-.923-.3-1.025-.5-1.025-.8 0-.4.41-.6.82-.6.307 0 .615.1.922.5l.513-.7c-.513-.4-1.025-.6-1.64-.6-1.025 0-1.845.7-1.845 1.6 0 .8.41 1.1 1.435 1.5.41.1.717.2.717.3.205.1.308.4.308.6.205.3-.205.7-.718.7m5.433.9c.512 0 .922-.1 1.435-.3v-1.2c-.41.4-.923.6-1.333.6-1.127 0-1.947-.8-1.947-1.9s.82-1.9 1.845-1.9c.512 0 .922.2 1.435.6v-1.3c-.513-.2-.923-.4-1.333-.4-1.64 0-3.075 1.3-3.075 2.9 0 1.7 1.333 2.9 2.973 2.9m10.762.1 2.46-5.7h-1.23l-1.537 3.7-1.538-3.8h-1.23l2.46 5.7h.615zm6.15-1.1h-2.05v-1.5h2.05v-.9h-2.05v-1.3h2.05v-.9h-3.177v5.6h3.177zm1.845-1.4h.205l1.538 2.2h1.332l-1.845-2.4c.923-.2 1.333-.7 1.333-1.6 0-1-.718-1.6-2.05-1.6h-1.64v5.6h1.127zm0-2.4h.41c.718 0 1.025.3 1.025.8s-.41.8-1.127.8h-.308z'
            ></path>
            <path
              fill='#F26E21'
              d='M21.783 15c1.698 0 3.075-1.343 3.075-3s-1.377-3-3.075-3-3.075 1.343-3.075 3 1.377 3 3.075 3'
            ></path>
          </svg>

          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='41'
            height='25'
            fill='none'
            viewBox='0 0 41 25'
            className={cn('flex-none', svgClassName)}
          >
            <rect
              width='40.8'
              height='23.616'
              x='0.1'
              y='0.694'
              fill='#fff'
              rx='1.9'
            ></rect>
            <rect
              width='40.8'
              height='23.616'
              x='0.1'
              y='0.694'
              stroke='#ABA6A0'
              strokeWidth='0.2'
              rx='1.9'
            ></rect>
            <path
              fill='#6666AC'
              d='M20.499 4.25a7.7 7.7 0 0 0-2.15 2.701 7.8 7.8 0 0 0-.766 3.383 7.76 7.76 0 0 0 2.916 6.083 7.7 7.7 0 0 0 2.15-2.701 7.8 7.8 0 0 0 .766-3.382 7.76 7.76 0 0 0-2.916-6.084'
            ></path>
            <path
              fill='#168ECD'
              d='M25.219 2.594A7.54 7.54 0 0 0 20.5 4.248a7.7 7.7 0 0 1 2.15 2.701 7.8 7.8 0 0 1 .766 3.383 7.76 7.76 0 0 1-2.917 6.083 7.54 7.54 0 0 0 4.718 1.655c4.217 0 7.635-3.464 7.635-7.738s-3.418-7.738-7.634-7.738m7.229 12.44-.09-.207h-.076v.3h.054v-.226l.084.196h.056l.084-.196v.226h.054v-.3h-.077zm-.477-.156h.099v.25h.054v-.25h.1v-.05h-.253z'
            ></path>
            <path
              fill='#DB141F'
              d='M17.583 10.332A7.76 7.76 0 0 1 20.5 4.25a7.54 7.54 0 0 0-4.719-1.655c-4.216 0-7.634 3.464-7.634 7.738s3.418 7.738 7.634 7.738c1.781 0 3.42-.619 4.719-1.654a7.7 7.7 0 0 1-2.15-2.701 7.8 7.8 0 0 1-.767-3.383'
            ></path>
            <path
              fill='#221E1F'
              d='M25.216 20.116v-.299h-.44v2.462h.445v-1.38c0-.407.144-.633.433-.633.09 0 .183.015.277.062l.136-.505a.8.8 0 0 0-.315-.067c-.255 0-.421.144-.536.36m-1.53 1.715c-.222 0-.293-.165-.293-.412v-1.112h.723v-.49h-.723v-.747h-.447v.747h-.414v.49h.414v1.122c0 .572.182.912.706.912a.9.9 0 0 0 .553-.191l-.128-.458a.7.7 0 0 1-.391.14m-4.687-2.075c-.597 0-1.013.524-1.013 1.292 0 .782.434 1.292 1.043 1.292.307 0 .588-.092.834-.345l-.217-.397a.86.86 0 0 1-.592.258c-.285 0-.544-.16-.608-.601h1.51q.009-.1.01-.207c-.005-.767-.397-1.292-.968-1.292m-.55 1.076c.048-.355.226-.598.541-.598.286 0 .468.216.515.598zm2.993-.031-.208-.036c-.192-.031-.345-.078-.345-.242 0-.18.145-.29.387-.29.26 0 .51.12.635.213l.19-.433c-.212-.17-.506-.258-.83-.258-.514 0-.847.299-.847.789 0 .401.248.648.703.726l.209.035c.243.041.358.12.358.258 0 .19-.162.299-.464.299a.97.97 0 0 1-.678-.258l-.208.417c.243.216.549.32.881.32.587 0 .928-.335.928-.804 0-.432-.268-.658-.71-.736m-7.226-1.045c-.26-.006-.528.092-.715.437-.14-.272-.362-.437-.673-.437-.217 0-.43.077-.596.365v-.304h-.443v2.462h.447v-1.364c0-.428.196-.655.499-.655.293 0 .442.232.442.649v1.37h.447v-1.364c0-.428.205-.655.498-.655.303 0 .447.232.447.649v1.37h.447v-1.545c0-.582-.306-.973-.8-.979m13.942.373q-.152-.178-.348-.274a1 1 0 0 0-.44-.1 1 1 0 0 0-.438.1 1.05 1.05 0 0 0-.345.273c-.1.117-.178.258-.232.413q-.083.237-.083.515 0 .279.084.517.081.237.23.411.145.175.346.274a1 1 0 0 0 .44.099 1 1 0 0 0 .437-.098c.262-.125.471-.372.58-.686q.083-.238.083-.516 0-.28-.084-.516a1.3 1.3 0 0 0-.23-.412m-.194 1.25a.8.8 0 0 1-.135.248.6.6 0 0 1-.205.164.56.56 0 0 1-.254.057.6.6 0 0 1-.253-.057.6.6 0 0 1-.204-.165.8.8 0 0 1-.134-.248 1 1 0 0 1-.048-.322q0-.175.048-.32a.8.8 0 0 1 .134-.248.57.57 0 0 1 .457-.224q.138 0 .254.058a.7.7 0 0 1 .34.414q.048.145.049.32 0 .175-.049.322m-10.896-1.263a.73.73 0 0 0-.643-.36c-.57 0-1.017.54-1.017 1.292 0 .751.447 1.293 1.017 1.293a.73.73 0 0 0 .643-.361v.299h.442v-2.461h-.442zm-.588 1.72c-.383 0-.617-.355-.617-.788 0-.432.234-.788.617-.788.366 0 .613.34.613.788s-.246.788-.613.788m12.714.234a.3.3 0 0 0-.044-.078.2.2 0 0 0-.066-.051.17.17 0 0 0-.193.02.24.24 0 0 0-.068.088.3.3 0 0 0-.01.211q.017.045.044.078c.04.046.092.072.147.072a.2.2 0 0 0 .146-.072.278.278 0 0 0 .044-.268m-.045.17a.2.2 0 0 1-.046.074.15.15 0 0 1-.07.04.13.13 0 0 1-.076-.005.16.16 0 0 1-.066-.048.213.213 0 0 1-.045-.135.23.23 0 0 1 .046-.135.2.2 0 0 1 .05-.04c.04-.02.084-.02.123 0q.029.014.05.04a.22.22 0 0 1 .033.209zm-.073-.07a.1.1 0 0 0 .012-.021.1.1 0 0 0 .004-.026q0-.015-.005-.029a.1.1 0 0 0-.015-.023.08.08 0 0 0-.056-.02h-.086v.227h.04v-.084h.018l.057.084h.048l-.061-.086a.07.07 0 0 0 .044-.022m-.106.001v-.077h.046q.015 0 .026.01a.04.04 0 0 1 .009.028q0 .02-.01.03a.04.04 0 0 1-.025.01z'
            ></path>
          </svg>
        </>
      ) : null}
    </div>
  );
};

export default PaymentImages;
